import * as ajaxService from './ajax-service';

export class BasketService {
    state = Vue.observable({
        basketData: { ID: 0, BASKET: { ...window.specialtyApp.initialBasketState } },
    });

    /**
     * Применяет к корзине промокод
     * @param coupon
     * @return {Promise<void>}
     */
    applyCoupon = async (coupon) => {
        const response = await ajaxService.post('/api/order/enter-coupon/', {
            data: {
                coupon,
            },
        });

        if (response?.data?.status === 'success') return;

        throw new Error(response?.data?.message || 'Возникла ошибка, повторите попытку позднее');
    }

    removeCoupon = async (coupon) => {
        const response = await ajaxService.post('/api/order/remove-coupon/', {
            data: {
                coupon,
            },
        });

        if (response?.data?.status === 'success') return;

        throw new Error(response?.data?.message || 'Возникла ошибка, повторите попытку позднее');
    }

    /**
     * Применяет к корзине промокод и обновляет корзину
     * @param coupon
     * @return {Promise<void>}
     */
    async applyCouponRefreshBasket(coupon) {
        await this.applyCoupon(coupon);
        await this.refreshBasket();
    }

    async removeCouponRefreshBasket(coupon) {
        await this.removeCoupon(coupon);
        await this.refreshBasket();
    }

    /**
     * Обновляет состояние корзины (запрашивает и применяет актуальное состояние)
     * @return {Promise<*>}
     */
    async refreshBasket() {
        return ajaxService.get('/api/basket/list/')
            .then((response) => {
                const { data: { data: basketData } } = response;

                this.setBasketData(basketData, 'list');
                return response;
            });
    }

    /**
     * Добавляет товар в корзину
     * @param productID Ид оффера для кофе или ид продукта лдя эвентов и оборудования
     * @param quantity количество
     * @param props дополнительные параметры, например помол для кофе
     * @return {Promise<Object>}
     */
    addToBasket(productID, quantity, props = {}) {
        return ajaxService.post('/api/basket/add/', {
            data: {
                product: productID,
                quantity,
                props,
            },
        }).then((response) => {
            const { data: { data: basketData } } = response;

            this.setBasketData(basketData);
            return response;
        });
    }

    /**
     * Добавляет товар в корзину
     * @param productID Ид оффера для кофе или ид продукта лдя эвентов и оборудования
     * @param quantity количество
     * @param props дополнительные параметры, например помол для кофе
     * @return {Promise<Object>}
     */
    mergeBasket (type) {
        return ajaxService.post('/api/basket/add-some-items/', {
            data: {
                mergeType: type,
            },
        }).then((response) => {
            const { data: { data: basketData } } = response;

            this.setBasketData(basketData);
            return response;
        });
    }

    /**
     * Обновляет параметры товара который уже в корзине
     * @param basketItemID - ИД элемента в корзине (см basketService.state.BASKET.GRID.ROWS)
     * @param quantity Количество
     * @return {Promise<*>}
     */
    updateInBasket(basketItemID, quantity, props) {
        return ajaxService.post('/api/basket/update/', {
            data: {
                basket: basketItemID,
                quantity,
                props,
            },
        }).then((response) => {
            const { data: { data: basketData } } = response;
            this.setBasketData(basketData);
            return response;
        });
    }

    /**
     * Удаляет товар из корзины по ИД
     * @param basketItemID - ИД элемента в корзине (см basketService.state.BASKET.GRID.ROWS)
     */
    async deleteFromBasket(basketItemID) {
        return ajaxService.post('/api/basket/delete/', {
            data: { basket: basketItemID },
        }).then((response) => {
            const { data: { data: basketData } } = response;
            this.setBasketData(basketData);
            return response;
        });
    }

    /**
     * Добавляет товар в корзину
     * @param productID Ид оффера для кофе или ид продукта лдя эвентов и оборудования
     * @param quantity количество
     * @param props дополнительные параметры, например помол для кофе
     */
    async recoverDeleteItem(productID, quantity, props = {}) {
        return ajaxService.post('/api/basket/add/', {
            data: {
                product: productID,
                quantity,
                props,
            },
        }).then((response) => {
            const { data: { data: basketData } } = response;
            this.setBasketData(basketData);
            return response;
        });
    }

    /**
     * Очищает корзину
     * @return {Promise<*>}
     */
    clearBasket() {
        return ajaxService.post('/api/basket/clear/').then((response) => {
            Vue.set(this.state.basketData.BASKET, 'ITEMS', Vue.observable({}));
            return response;
        });
    }

    constructor() {
        this.state.basketData = Vue.observable(this.state.basketData);
    }

    /**
     * Обновляет стейт сервиса после операций с корзиной
     * @param basketData
     */
    setBasketData(basketData, mode = 'default') {
        if (mode === 'list') {
            Vue.set(this.state.basketData, 'BASKET', Vue.observable(basketData));
            return;
        }

        Vue.set(this.state, 'basketData', Vue.observable(basketData));
    }
}
